import React, { FC, useMemo } from 'react';
import { observer } from "mobx-react-lite";
import checkMark from "../../../assets/CheckMarkGray.svg";
import checkMarkWhite from "../../../assets/CheckMarkWhite.svg";
import '../BoardActionModeButton/ActionModeButton.css';

export interface IActionModeButtonProps {
    onClickFunc: () => void;
    isActive: boolean;
    selectedCount: number;
}

const BtnActionMode: FC<IActionModeButtonProps> = ({ onClickFunc, isActive, selectedCount }) => {
    const checkIcon = useMemo(() => 
        isActive ? checkMarkWhite : checkMark, 
        [isActive]
    );

    const className = useMemo(() => {
        const baseClass = "action-mode-button";
        const classes = [baseClass];
        
        if (isActive) classes.push("active");
        if (selectedCount === 0) classes.push("empty");
        
        return classes.join(" ");
    }, [isActive, selectedCount]);

    const imageStyle = useMemo(() => ({
        width: "18px", 
        height: "18px"
    }), []);

    return (
        <div className={className} onClick={onClickFunc}>
            <img 
                style={imageStyle} 
                src={checkIcon} 
                alt={isActive ? "Active mode" : "Inactive mode"} 
            />
        </div>
    );
};

export default observer(BtnActionMode);